<template lang="pug">
    PrintablePanel
      ICEAlert
      PageHeader Person Watch Hits
      .row(v-if="!printable")
        .col
        .col-1.text-right
          router-link.btn.btn-primary(:to="{query: {print: true}}" target="_blank") Print
      .row(v-if="!printable")
        .col
          SearchBar.search-bar.body-1(v-model="filter")
      Datatable.mt-3.body-2(:columns="columns"
        :entries="filteredEntries"
        :per-page="6")
        template(slot-scope="props")
          tr
            td
              div(v-if="props.entry.newHit")
                TinyTag New Hit
              router-link(:to="{name: 'person_summary', params: {id: props.entry.subjectSid}}") View Summary
            td {{ props.entry.lastName }}, {{ props.entry.firstName }}
            td {{ props.entry.birthDt }}
            td {{ props.entry.idNbr }}
            td {{ props.entry.transactionDt }}
            td {{ props.entry.stateCd }}
            td {{ props.entry.pharmacyName }}
</template>

<script>
import SearchBar from '@/components/SearchBar'
import Datatable from '@/components/Datatable'
import PageHeader from '@/components/PageHeader'
import PrintablePanel from '@/components/PrintablePanel'
import TinyTag from '@/components/TinyTag'
import { globalError } from '@/lib/utils'
import axios from '@/lib/axios'

export default {
  name: 'WatchHits',
  data: function() {
    return {
      filter: '',
      entries: [],
      columns: [
        'Details',
        'Name',
        'Date of Birth',
        'Unique IDs',
        'Record Date',
        'State',
        'Pharmacy',
      ],
    }
  },
  computed: {
    filteredEntries: function() {
      let filter = this.filter
        .toLowerCase()
        .replace(/^\s+/, '')
        .replace(/\s+$/, '')
      if (filter === '') {
        return this.entries
      }
      let entries = []
      for (let entry of this.entries) {
        if (entry.firstName.toLowerCase().includes(filter)) entries.push(entry)
        else if (entry.lastName.toLowerCase().includes(filter))
          entries.push(entry)
        else if (entry.birthDt.includes(filter)) entries.push(entry)
        else if (entry.idNbr && entry.idNbr.toLowerCase().includes(filter))
          entries.push(entry)
        else if (entry.transactionDt.includes(filter)) entries.push(entry)
        else if (entry.stateCd.toLowerCase().includes(filter))
          entries.push(entry)
        else if (
          entry.pharmacyName &&
          entry.pharmacyName.toLowerCase().includes(filter)
        )
          entries.push(entry)
      }
      return entries
    },
  },
  async beforeRouteEnter(to, _from, next) {
    try {
      let resp = await axios().get('/api/watch/hits', { params: { sid: to.params.id }})
      await axios().put('api/watch/watch_status', { watchSids: [to.params.id] })
      next(vm => {
        vm.entries = resp.data
        if (vm.printable) vm.$nextTick(() => window.print())
      })
    } catch(err) {
      globalError(err)
    }
  },
  components: {
    SearchBar,
    Datatable,
    PageHeader,
    TinyTag,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';

.panel-white {
  width: 1007px;
}

@media (min-width: $bp-lg) {
  .search-bar {
    width: 25%;
    margin-left: auto;
  }
}
</style>
